<h2 mat-dialog-title>Numeraciones</h2>
<mat-dialog-content class="mat-typography">
    @if(loading){
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    @if(numeracionesDocumento.length > 0) {
    <div class="header">
        <div>DEPARTAMENTOS</div>
        <div>PLANTILLA</div>
    </div>
    }@else {
    <div>No dispone de numeraciones</div>
    }
    <div>
        <mat-radio-group aria-labelledby="numeraciones" class="dialog-config" [(ngModel)]="numeracionSeleccionada">
            @for (season of numeracionesDocumento; track season) {
            <mat-radio-button class="listado-config" [value]="season">
                <div>
                    <div>{{season.departamento}}</div>
                    <div>{{season.numeracion}}</div>
                </div>
            </mat-radio-button>
            }
        </mat-radio-group>
    </div>
    @if (numeracionSeleccionada) {
    <p>Selecci&oacute;n: {{numeracionSeleccionada.departamento}}</p>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cerrar</button>
    <button type="button" mat-button matSuffix class="numeracion-field" matTooltip="Editar n&uacute;mero"
                (click)="onEditConfirm()">Editar                
              </button>
    <button mat-flat-button [disabled]="!numeracionSeleccionada" (click)="onDlgAccepted()">
        <p>Aceptar</p>
    </button>
</mat-dialog-actions>